<template>
  <div class="">
    <b-button pill v-b-modal.wallet-history>جزییات تراکنش</b-button>

    <b-modal dir="rtl" size="lg" id="wallet-history" hide-footer>
      <div class="text-right" dir="rtl">
        <div v-for="history in histories ">
          <p>از طرف
            <span v-html="chargeable(history)"></span>
          </p>
          <p>
            تاریخ:
            {{ dateConverter(history.created_at, '/', true) }}
          </p>
          <p class="my-4">
            مبلغ:
            {{ formatNumber(Math.abs(history.value)) }}
          </p>

          <p>
            توضیحات:
            {{ history.description }}
          </p>


          <hr>
        </div>
      </div>

      <pagination :meta="meta" :on-change-page="changePage"/>

    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {formatNumber, dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

import Pagination from "../../../components/dashboard/Pagination.vue";

export default {
  name: "HistoryWallet",
  components: {Pagination},
  props: {
    user_id: {},
  },
  computed: {
    ...mapGetters({
      histories: 'Wallet/getHistories',
      meta: 'Wallet/getHistoriesMeta',
    })
  },
  methods: {
    formatNumber,
    dateConverter,
    chargeable(history) {
      const chargeable = history.chargeable
      if (history.chargeable_type == 'user') {
        return `${chargeable.name} ${chargeable.last_name}`
      }
      if (history.chargeable_type == 'order') {

        let routeData = this.$router.resolve({name: 'Factor', params: {orderId: chargeable.id}});
        return `<a class="text-decoration-none" target="_blank" href="${routeData.href}">سفارش</a>`
      }
    },
    changePage(page) {
      const form = {
        user_id: this.user_id,
        page: page
      }
      this.$store.dispatch("Wallet/walletHistories", form);
    },
  },
  watch: {
    user_id: function (newVal, oldVal) { // watch it

      const form = {
        user_id: newVal,
        page: 1
      }
      this.$store.dispatch('Wallet/walletHistories', form)

    }
  }
}
</script>

<style scoped>

</style>